// src/pages/HomePage.js
import React from 'react';
import { Link } from 'react-router-dom';

const KIMP_URL = 'https://kimp.honeypot-ant.com/';

const sections = [
    {
        category: '백테스팅',
        description: '전략별 과거 성과를 데이터로 검증합니다.',
        links: [
            { to: '/backtest/backtest-lazy-portfolio', name: '정적 자산배분' },
            { to: '/backtest/backtest-11to4', name: '11to4 전략' },
            { to: '/backtest/strategy-oecd-cli', name: 'OECD CLI 기반 롱 전략' },
            { to: '/backtest/strategy-inverse-oecd-cli', name: 'OECD CLI 기반 숏 전략' },
            { to: '/backtest/strategy-oecd-cli-di', name: 'OECD CLI 확산 지수' },
        ],
    },
    {
        category: '수출 데이터',
        description: '한국 수출 동향과 품목·지역별 통계를 한눈에.',
        links: [
            { to: '/kr-trade/export-summary-now', name: '수출 NOW' },
            { to: '/kr-trade/export-summary', name: '과거 연도별 수출' },
            { to: '/kr-trade/stock-vs-export', name: '주가 vs 품목별 수출' },
            { to: '/kr-trade/export-summary-now_regional', name: '지역별 수출 NOW' },
            { to: '/kr-trade/export-summary-regional', name: '과거 연도별 지역별 수출' },
            { to: '/kr-trade/export-by-region', name: '지역별 품목별 수출 그래프' },
        ],
    },
    {
        category: '한국 시장',
        description: 'KRX 주가지수 밸류에이션·어닝·수출 연계 분석.',
        links: [
            { to: '/krx-market/krx-idx-vs-trade', name: '주가지수 vs 수출' },
            { to: '/krx-market/valuation', name: '주가지수 밸류에이션 밴드' },
            { to: '/krx-market/earnings', name: '주가지수 vs 어닝' },
        ],
    },
    {
        category: '글로벌 시장',
        description: '글로벌 주식·자산 성과 비교 및 금 수요 트렌드.',
        links: [
            { to: '/global/global-market-performance', name: '글로벌 주식시장 성과' },
            { to: '/global/all-asset-performance', name: '자산별 성과' },
            { to: '/global/gold_demand_trends', name: '금 수요 트렌드' },
        ],
    },
];

const HomePage = () => {
    return (
        <div style={{ maxWidth: '960px', margin: '0 auto', padding: '1.5rem 1.25rem 4rem' }}>

            {/* Site intro */}
            <header style={{ marginBottom: '3rem' }}>
                <h1 style={{ fontSize: 'clamp(1.6rem, 3.5vw, 2.4rem)', fontWeight: 700, color: '#0f1117', lineHeight: 1.25, margin: '0 0 1rem' }}>
                    개미를 위한<br />금융 데이터 분석 플랫폼
                </h1>
                <p style={{ fontSize: '1rem', color: '#57606a', lineHeight: 1.7, maxWidth: '520px', margin: 0 }}>
                    백테스팅, 수출 통계, 주가 분석, 글로벌 시장 성과를 데이터로 확인하세요.
                    합리적인 투자 결정을 돕기 위한 무료 시각화 도구를 제공합니다.
                </p>
            </header>

            {/* 김프 랩 shortcut */}
            <a
                href={KIMP_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'block', textDecoration: 'none', marginBottom: '3rem' }}
            >
                <div
                    style={{
                        border: '1px solid #e1e4e8',
                        borderRadius: '10px',
                        padding: '1.5rem 1.75rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '1rem',
                        background: '#fafafa',
                        transition: 'border-color 0.2s, box-shadow 0.2s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = '#0064FF'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0,100,255,0.08)'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = '#e1e4e8'; e.currentTarget.style.boxShadow = 'none'; }}
                >
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.4rem' }}>
                            <span style={{ fontSize: '1rem', fontWeight: 700, color: '#0f1117' }}>김프 랩</span>
                            <span style={{
                                fontSize: '0.65rem', fontWeight: 700, color: '#fff',
                                background: '#0064FF', borderRadius: '4px',
                                padding: '1px 6px', letterSpacing: '0.05em',
                            }}>NEW</span>
                        </div>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: '#57606a', lineHeight: 1.6 }}>
                            금·암호화폐 실시간 김치 프리미엄 모니터링 — 과거 추이 분석 및 트레이딩 전략 백테스트
                        </p>
                    </div>
                    <span style={{ fontSize: '1.25rem', color: '#8b949e', flexShrink: 0 }}>→</span>
                </div>
            </a>

            {/* Feature grid */}
            <section>
                <h2 style={{ fontSize: '0.78rem', fontWeight: 600, color: '#8b949e', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
                    전체 메뉴
                </h2>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))',
                    gap: '1px',
                    background: '#e1e4e8',
                    border: '1px solid #e1e4e8',
                    borderRadius: '10px',
                    overflow: 'hidden',
                }}>
                    {sections.map((section) => (
                        <div key={section.category} style={{ background: '#fff', padding: '1.5rem' }}>
                            <h3 style={{ fontSize: '0.875rem', fontWeight: 700, color: '#0f1117', margin: '0 0 0.3rem' }}>
                                {section.category}
                            </h3>
                            <p style={{ fontSize: '0.78rem', color: '#8b949e', margin: '0 0 1rem', lineHeight: 1.5 }}>
                                {section.description}
                            </p>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                {section.links.map((link) => (
                                    <li key={link.to}>
                                        <Link
                                            to={link.to}
                                            style={{ fontSize: '0.85rem', color: '#24292f', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.35rem' }}
                                            onMouseEnter={e => { e.currentTarget.style.color = '#0064FF'; }}
                                            onMouseLeave={e => { e.currentTarget.style.color = '#24292f'; }}
                                        >
                                            <span style={{ color: '#d0d7de', fontSize: '0.65rem' }}>▸</span>
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </section>

            <footer style={{ marginTop: '3rem', paddingTop: '1.5rem', borderTop: '1px solid #e1e4e8', fontSize: '0.78rem', color: '#8b949e', lineHeight: 1.6 }}>
                본 플랫폼의 모든 정보는 투자 참고 자료이며, 특정 자산의 매수·매도를 추천하지 않습니다. 최종 투자 결정과 책임은 투자자 본인에게 있습니다.
            </footer>
        </div>
    );
};

export default HomePage;
